import React, { useState, useEffect } from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core';

import TimeSelector from './components/appointment-selector/components/time-selector';
import {
  filterTimeSlotsByProviderLocation,
  arrangeUniqTimeSlots,
  ConvertToAmPmTimeSlots,
  isAvailableSlot,
} from './utils';
import { activeTabs, locationNotAvailable } from './constants';

export const LocationsList = (props) => {
  const {
    options,
    activeTab,
    listOfSelectedLocations,
    selectedDay,
    timeSelectorField,
    timeSlots,
    selectedTime,
    onTimeClick,
    readOnly,
    isMultiLocation,
    noLocationFoundMessage,
    selectedProviderId,
    activePanels,
    changeActivePanels,
    timeZone
  } = props;

  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectTimeLocationId, setSelectTimeLocationId] = useState({
    time: selectedTime,
    locationId: null
  });

  useEffect(() => {
    // Update location based on radius or selected day
    updateLocationList();

    // Handle setting the accordian to the first location (or NULL) if the day changes
    const id = selectTimeLocationId.locationId ? [selectTimeLocationId.locationId] :[options?.[0]?.id]
    changeActivePanels(selectedDay ? id : []);

    //
    unselectSlot();                                                               
  }, [options, activeTab, listOfSelectedLocations, selectedDay]);

  useEffect(() => {
    if (!selectedTime)
      setSelectTimeLocationId({
        time: null,
        locationId: null
      });
  }, [selectedTime]);

  const handleLocationExpand = (id) => {
    // Convert the activePanels prop to an array if it isn't already
    const activePanelsArray = Array.isArray(activePanels) ? activePanels : [];

    // Determine first if the selected panel is already active
    const isActive = activePanelsArray?.indexOf(id) !== -1;

    // If it is active, remove it from the array, otherwise add it
    if (isActive) {
      changeActivePanels(activePanelsArray.filter((panelId) => panelId !== id));
    } else {
      changeActivePanels([...activePanelsArray, id]);
    }
  };

  const updateLocationList = () => {
    let filterData = [];
    switch (activeTab) {
      case activeTabs.location:
        filterData = options.filter(
          (location) => listOfSelectedLocations.indexOf(`${location.id}`) !== -1
        );
        break;
      default:
        filterData = options;
    }
    
    setSelectedLocations([...filterData]);
  };

  const getTimeSlots = (locationId) => {
    let fullDaytimeSlots = timeSlots || [];
    const locationTimeSlots = filterTimeSlotsByProviderLocation(
      fullDaytimeSlots,
      [locationId]
    );
    fullDaytimeSlots = arrangeUniqTimeSlots(
      locationTimeSlots,
      selectedProviderId,
      timeZone
    );

    // divide slots into am/pm
    return ConvertToAmPmTimeSlots(fullDaytimeSlots);
  };

  const getTimeSlotsCount = (locationId) => {
    let fullDaytimeSlots = timeSlots || [];
    const locationTimeSlots = filterTimeSlotsByProviderLocation(
      fullDaytimeSlots,
      [locationId]
    );
    fullDaytimeSlots = arrangeUniqTimeSlots(
      locationTimeSlots,
      selectedProviderId,
      timeZone
    );
    fullDaytimeSlots = fullDaytimeSlots.filter(
      (slot) => isAvailableSlot(slot.time,timeZone)
    );

    return fullDaytimeSlots.length;
  };

  const handleTimeClick = (time, locationId) => {
    // unselect time if same selected again
    time =
      selectTimeLocationId.locationId === locationId &&
      selectTimeLocationId.time === time
        ? null
        : time;
    locationId = time ? locationId : null;
    onTimeClick(time, locationId);
    setSelectTimeLocationId({ time, locationId });
  };

  const unselectSlot = () => {
    if (selectTimeLocationId.locationId) {
      const locationData = listOfSelectedLocations.filter(
        (location) => location === `${selectTimeLocationId.locationId}`
      );
      if (locationData.length === 0) handleTimeClick();
    }
  };

  return (
    <>
      {options && options.length > 0 ? (
        <>
          {selectedLocations &&
            selectedLocations.map((item, id) => (
              <div
                className="form-field-location-list"
                style={{
                  display: 'block',
                  width: '100%',
                  marginBottom: '20px'
                }}
              >
                <Accordion
                  key={id}
                  expanded={activePanels?.indexOf(item.id) !== -1}
                  onChange={() => handleLocationExpand(item.id)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    style={{ flexDirection: 'column' }}
                  >
                    <div className="heading">{item.displayName} </div>
                    <div className="sub-heading">
                      <div style={{ width: '70%', color: 'text.secondary' }}>
                        {item.street}{' '}
                        {isMultiLocation &&
                          activeTab === activeTabs.radius &&
                          `(${item.radius} mi)`}
                      </div>
                      <div style={{ width: '30%', color: 'text.secondary' }}>
                        {`${getTimeSlotsCount(parseInt(item.id))} Available`}
                      </div>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    {selectedDay && (
                      <TimeSelector
                        id={timeSelectorField.uuid}
                        timeSlots={getTimeSlots(parseInt(item.id))}
                        selectedTime={
                          selectTimeLocationId.locationId === item.id
                            ? selectTimeLocationId.time
                            : null
                        }
                        onTimeClick={(time) => {
                          handleTimeClick(time, item.id);
                        }}
                        readOnly={readOnly}
                        timeZone={timeZone}
                      />
                    )}
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          {selectedLocations && selectedLocations.length === 0 && (
            <span style={{ marginBottom: '12px' }}>
              {activeTab === activeTabs.radius && locationNotAvailable}
            </span>
          )}
        </>
      ) : (
        <div style={{ marginBottom: '12px', fontWeight:"bold" }}>
          {noLocationFoundMessage}
        </div>
      )}
    </>
  );
};

export default LocationsList;
